import React from 'react';

import PushNotificationsManagement from '../../components/Admin/PushNotificationsManagement'

import MainBlockHeader from '../MainBlockHeader'
import MainBlockContainer from '../MainBlockContainer';
import { useTranslation } from 'react-i18next';

export default function PushNotificationsPage() {
  const { t } = useTranslation();

  return (
    <>
      <MainBlockHeader header={t('admin.pushNotifications.pageTitle')} >
      </MainBlockHeader>

      <MainBlockContainer>
        <PushNotificationsManagement />
      </MainBlockContainer>
    </>
  );
}
